import { render, staticRenderFns } from "./tab-content-lazy.vue?vue&type=template&id=9716b11e&"
import script from "./tab-content-lazy.vue?vue&type=script&lang=js&"
export * from "./tab-content-lazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports